(function() {
  'use strict';
  angular.module('com.vmware.vsphere.client.folder')
    .controller('VchaPortletController', VchaPortletController);

  VchaPortletController.$inject = ['$scope', 'i18nService'];

  function VchaPortletController($scope, i18nService) {
    $scope.portlet.footerLinks = [{
      label: i18nService.getString('FolderUi', 'vcha.portlet.footer.settings'),
      onClick: function () {
        $scope._navigate('vsphere.core.folder.manage.settings.vchaView', $scope._route.objectId);
      },
      enabled: true
    }];
  }
}());